module.exports = __webpack_public_path__ + "static/6305-woodrose-27-d2611e1b181d80ddfb388d8355bfbdfc.jpg";